import classNames from 'classnames';
import {
  useAlerts,
} from '@dinosave/core/stores';
import type {
  AlertEntity,
} from '@dinosave/core/types';
import Button from '@/ui/components/Button';
import Text from '@/ui/components/Text';
import {
  CloseIcon,
  CheckCircleIcon,
  CloseCircleIcon,
} from '@/ui/icons';

import styles from './Alert.module.css';

type AlertProps = {
  index: number;
  alert: AlertEntity;
}

const Alert = (props: AlertProps) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    alert,
  } = props;

  const {
    id,
    type,
    title,
    message,
    image,
    deleted,
  } = alert;

  // ##########################################################################
  // STORES
  // ##########################################################################

  const removeAlert = useAlerts(s => s.removeAlert);

  // ##########################################################################
  // FUNCTIONS
  // ##########################################################################

  const handleClose = () => removeAlert(id);

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const alertClassName = classNames({
    [styles.alert]: true,
    [styles.deleted]: deleted,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  let Icon = null;

  if (
    type === 'error'
  ) Icon = CloseCircleIcon;

  if (
    type === 'success'
  ) Icon = CheckCircleIcon;

  return (
    <div
      className={alertClassName}
      data-component="Alert"
    >
      {image ? (
        <div className={styles.image}>
          <img
            src={image}
            alt={type}
          />
        </div>
      ) : (
        <div className={styles.icon}>
          <Icon />
        </div>
      )}

      <div className={styles.description}>
        {title && (
          <div className={styles.title}>
            <Text
              kind="paragraph"
              size="regular"
              color="neutral-500"
            >
              {title}
            </Text>
          </div>
        )}

        {message && (
          <div className={styles.message}>
            <Text
              kind="heading-6"
              color="neutral-600"
              weight="600"
            >
              {message}
            </Text>
          </div>
        )}
      </div>

      <div className={styles.close}>
        <Button
          kind="ghost"
          color="secondary"
          roundness="round"
          onClick={handleClose}
          centered
        >
          <CloseIcon />
        </Button>
      </div>
    </div>
  );
};

export default Alert;
